<div class="flex justify-content-center p-0">
	<div class="p-col-12 p-md-6 p-lg-3 px-3 py-0">
		<div class="flex justify-content-center p-0">
			<div class="p-col-12 p-md-6 p-lg-3 p-0">
				<h3 >{{ 'h3.denialConfirmation' | translate }}</h3>
			</div>
		</div>

		<div class="pb-0">
			<label>{{ 'h5.labelCode' | translate }}</label>
				<input  type="text" minlength="1" maxlength="21" min="1" tabindex="-1" pInputText
						[ngClass]="{focusField: inputFields[0].focus}" [id]="inputFields[0].id"
						(keydown.enter)="getDenialParts()" [(ngModel)]="inputFields[0].value">
		</div>

		<div class="card pl-3 pb-2 pt-0"  *ngIf="showDescriptionDenial">
			<div class="p-1 z-0">
				<h5>{{ 'h5.part' | translate }}:  <span class="text-sm opacity-60 ">{{ denials.partName }}</span></h5>
				<h5>{{ 'h5.description' | translate }}:  <span class="text-sm opacity-60 ">{{ denials.shortName }}</span></h5>
				<h5>{{ 'h5.staging' | translate }}:  <span class="text-sm opacity-60 ">{{ denials.locationC }}</span></h5>
			</div>
		</div>

		<div class="pb-0">
			<label>{{ 'h5.staging' | translate }}</label>
			<input  type="text" pInputText tabindex="-1"
					[disabled]="!inputFields[1].valid" (keydown.enter)="checkLocation()"
					[(ngModel)]="this.inputFields[1].value" (ngModelChange)="invalidLocation()">
		</div>

		<div class="pb-0">
			<label>{{ 'h5.quantity' | translate }}</label>
			<input  type="number" inputmode="numeric" min="1" maxlength="16" tabindex="-1"
					class="form-control" pInputText
					[(ngModel)]="inputFields[2].value" (ngModelChange)="invalidQuantity()"
					id="" [disabled]="!this.inputFields[2].valid" (keydown.enter)="validQuantity()"
					onkeydown="if(event.key==='.' || event.key==='-' || event.key==='+' || event.key==='e'){event.preventDefault();}">
		</div>

		<div class="flex justify-content-center p-0">
			<div class="p-col-12 p-md-6 p-lg-3 p-0">
				<button pButton class="submit" [disabled]="saveIsOk" (click)="saveDenialLabel()">{{ 'button.save' | translate }}</button>
			</div>
		</div>
	</div>
</div>

<input-generic
	[inputFields]="inputFields"
	(eventEmitter)="executeAction($event)">
</input-generic>

<alert-custom *ngIf="showAlert"
	(onCloseModal)="hideErrorModal($event)"
	[msg]="errorMessage"
	[elId]="errorFocus"
	[title]="errorTitle">
</alert-custom>
